<template>
    <div class="home-view c-text-center">词汇星球证书查询</div>
</template>

<script>

export default {
    name: 'HomeView',
    components: {
    },
    data() {
        return {}
    }
}
</script>

<style scoped lang="less">
.home-view {
    margin-top: 120px;
    font-size: 18px;
}
</style>
